import { Debug } from "@utils/debug";
import { DeviationsLoader } from "../deviations.loader";
import { IRawDeviation, TApiGetTasksResponse } from "@propely/propely-typings";
import { convertApiTaskToRawTask } from "../deviations.types";
import { propelyApi } from "@libs/firebase/api";
import { LocalData } from "@LocalData/General/LocalData";

export class ApiDeviationsLoader {
  //private static readonly baseURL_local = "http://localhost:8080/api/v1";
  //  static getURL = () => propelyApiUrl();
  static getURL = () => {
    return process.env.REACT_APP_API_URL!;
  };

  startDate = new Date();
  deviationCount = 0;
  deviations: IRawDeviation[] = [];
  loaded: boolean = false;
  loading: boolean = false;
  deviationsLoader: DeviationsLoader;

  remainingApiCalls = 0;

  constructor(deviationsLoader: DeviationsLoader) {
    this.deviationsLoader = deviationsLoader;
  }

  private handleDataWithZodParsing(startDate: Date, data: any) {
    let convertedDeviations: IRawDeviation[] = [];
    try {
      const startParsingDate = new Date();
      const parsedDeviations = TApiGetTasksResponse.parse(data).datas;
      convertedDeviations = parsedDeviations.map((deviation) => convertApiTaskToRawTask(deviation));
      this.deviations.push(...convertedDeviations);
      console.log("[ApiDeviationsLoader] Parsing time " + (new Date().getTime() - startParsingDate.getTime()) + " ms");
      console.log("[ApiDeviationsLoader] Total time " + (new Date().getTime() - startDate.getTime()) + " ms for " + parsedDeviations.length);
    } catch (error) {
      console.log("[ApiDeviationsLoader] Error parsing deviations");
      console.error(error);
    }
    this.deviationCount = this.deviations.length;
    this.finishedLoading(convertedDeviations);
    return this.deviations;
  }

  loadDeviations(): Promise<any> {
    this.startDate = new Date();

    console.log("[ApiDeviationsLoader] Loading deviations");

    if (this.loaded || this.loading) {
      console.log("[ApiDeviationsLoader] Already loaded deviations");
      return Promise.resolve(this.deviations);
    }

    this.deviations = [];
    this.loading = true;

    const promises: Promise<any>[] = [];

    const apiURL = ApiDeviationsLoader.getURL();
    const startDate = new Date();

    promises.push(this.callApi(startDate, apiURL, false));

    // Some companies should not load archived deviations (for now)
    const companyIDsToExclude = ["y2ppneZ3YJow2GYHSJsX"]; // Vaxa
    if (LocalData.currentUser && !LocalData.currentUser.companies.some((c) => companyIDsToExclude.includes(c.id))) {
      promises.push(this.callApi(startDate, apiURL, true));
    }
    return Promise.all(promises);
  }

  private callApi = (startDate: Date, apiURL: string, archived: boolean) => {
    const fullURL = apiURL + "/tasks?archived=" + archived;
    console.log("[ApiDeviationsLoader] Loading deviations from " + fullURL);

    this.remainingApiCalls++;
    return propelyApi()
      .get(fullURL)
      .then((response) => {
        console.log("[ApiDeviationsLoader] Loaded deviations for archived=" + archived);
        return this.handleDataWithZodParsing(startDate, response.data);
      })
      .catch((error) => {
        console.log("[ApiDeviationsLoader] error", error);
        console.error(error);
        this.finishedLoading([]);
        return [];
      });
  };

  private finishedLoading(data: IRawDeviation[]) {
    this.remainingApiCalls--;
    if (this.remainingApiCalls > 0) {
      this.deviationsLoader.addDeviations(data, "ApiDeviationsLoader");

      return;
    }
    Debug.print("[ApiDeviationsLoader] Finished loading deviations");
    Debug.print("[ApiDeviationsLoader] Total deviations " + this.deviationCount);
    Debug.print("[ApiDeviationsLoader] Time " + (new Date().getTime() - this.startDate.getTime()) + " ms");
    this.loaded = true;
    this.loading = false;
    this.deviationsLoader.addDeviations(this.deviations, "ApiDeviationsLoader");
  }
}
